<template lang="pug">
    div.expandCard
        table.c-table
            tr
                td {{ $t('fields.email') }}
                td {{ item.email }}

            tr(v-if="item.phone")
                td {{ $t('fields.phone') }}
                td {{ item.phone | phoneNumber }}

            tr
                td {{ $t('fields.status') }}
                td {{ item.isActive ? $t('fields.active') : $t('fields.inactive') }}

            tr
                td {{ $t('fields.role') }}
                td.capitalize {{ item.role }}
</template>

<script>
    import VueTypes from 'vue-types';
    import phoneNumber from '~filters/Phone';

    export default {
        filters: {
            phoneNumber
        },
        props: {
            item: VueTypes.object.def({})
        }
    };
</script>

<style lang="stylus" scoped>
    .expandCard
        width: 100%;
        padding-left: 30px
        background: linear-gradient(90deg, #022341 50%, rgba(2, 35, 65, 0) 100%);

        table tr
            td
                height: 38px

            td:first-child
                color: rgba(255, 255, 255, 0.6) !important

    .capitalize
        text-transform: capitalize
</style>
